var map = {
	"./0.svg": 1299,
	"./1.svg": 5450,
	"./10.svg": 4458,
	"./11.svg": 3408,
	"./12.svg": 9890,
	"./13.svg": 1588,
	"./14.svg": 6839,
	"./15.svg": 7340,
	"./16.svg": 2880,
	"./17.svg": 3877,
	"./18.svg": 7636,
	"./19.svg": 5105,
	"./2.svg": 4689,
	"./3.svg": 3618,
	"./4.svg": 9496,
	"./5.svg": 5349,
	"./6.svg": 1085,
	"./6b.svg": 1746,
	"./7.svg": 681,
	"./8.svg": 8039,
	"./9.svg": 4397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8111;